const AUTH_REQUEST_ID_KEY = 'AUTH_REQUEST_ID';
export default class AuthRequestService {
  static storeAuthRequestId(connectionFlowId: string) {
    localStorage.setItem(AUTH_REQUEST_ID_KEY, connectionFlowId);
  }

  static getAuthRequestId(): string {
    return localStorage.getItem(AUTH_REQUEST_ID_KEY) || '';
  }
}
